module.exports = __webpack_public_path__ + "img/16l007-15.6da6fb73.jpg";